import Vue from 'vue'
import App from './App.vue'
import router from './utils/routers'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/iconfont/iconfont.css'
import '@/assets/css/cus.css'


//配置全局api  青岛：api    防灾：api1
Vue.prototype.$api ='/api';


// 导入moment.ja
import moment from 'moment'
Vue.prototype.$moment = moment;

import ajax from './utils/ajax'
Vue.prototype.$ajax = ajax;
import message from './utils/message'
Vue.prototype.$message = message;
import store from './utils/store'
Vue.prototype.$store = store;
import scroll from 'vue-seamless-scroll'
Vue.component("vueSeamlessScroll", scroll)
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import animate from 'animate.css'
Vue.use(animate)

//全局注册自定义组件
import orgTree from './components/common/es-org-tree'
import esPagination from './components/common/es-pagination'
import esDelete from './components/common/es-delete'
import esExtend from './components/common/es-extend'
import esImg from './components/common/es-img'

Vue.component('esOrgTree', orgTree)
Vue.component('esPagination', esPagination)
Vue.component('esDelete', esDelete)
Vue.component('esExtend', esExtend)
Vue.component('esImg', esImg)


Vue.config.productionTip = false
Vue.use(Element);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
